import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { findNext, isTop, isBottom } from '../../utils/dropdowns.js';

function makeMenuItems(items, placeholder) {
  var native = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (placeholder !== '') {
    return [{
      value: native ? '' : null,
      label: placeholder,
      disabled: true
    }].concat(_toConsumableArray(items));
  }
  return items;
}
function buildHandler(event, items, option, handleChange, setExpanded, toggleExpanded) {
  return {
    Escape: function Escape() {
      return setExpanded(false);
    },
    Enter: toggleExpanded,
    ' ': toggleExpanded,
    End: function End() {
      return handleChange(event, findNext(items.length, items, 'Up'));
    },
    Home: function Home() {
      return handleChange(event, findNext(0, items, 'Down'));
    },
    ArrowUp: function ArrowUp() {
      setExpanded(true);
      handleChange(event, isTop(items, option) ? 0 : findNext(option, items, 'Up'));
    },
    ArrowDown: function ArrowDown() {
      setExpanded(true);
      handleChange(event, isBottom(items, option) ? items.length - 1 : findNext(option, items, 'Down'));
    }
  };
}
function getSelectedIndex(items, value) {
  var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (value !== null) {
    return items.findIndex(function (x) {
      return x.value === value && !x.disabled;
    });
  }
  return selected;
}
function getSelectedItemDetails(items, selected) {
  return {
    value: items[selected] && items[selected].value,
    label: items[selected] && items[selected].label,
    isDisabled: items[selected] ? items[selected].disabled : false
  };
}

export { buildHandler, getSelectedIndex, getSelectedItemDetails, makeMenuItems };
